'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var MockStorageDriver = require('./MockStorageDriver.cjs');

const mockStorage = options => ({
  install(metaplex) {
    metaplex.storage().setDriver(new MockStorageDriver.MockStorageDriver(options));
  }
});

exports.mockStorage = mockStorage;
//# sourceMappingURL=plugin.cjs.map
